exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-04ef1a9c],.fade-leave-active[data-v-04ef1a9c]{\n  -webkit-transition:all .32s ease;\n  transition:all .32s ease\n}\n.fade-enter[data-v-04ef1a9c],.fade-leave-to[data-v-04ef1a9c]{\n  opacity:0\n}", ""]);

// exports
